<template>
  <div>
    <svg
        :width="iconSize"
        :height="iconSize"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
      <path
          d="M21 6H13L11 4H5C3.89913 4.0053 3.00957 4.89913 3.00957 6L3 18C3.0033 19.1032 3.89678 19.9967 5 20H21C22.1032 19.9967 22.9967 19.1032 23 18V8C22.9967 6.89678 22.1032 6.0033 21 6ZM16 9C17.1046 9 18 9.89539 18 11C18 12.1046 17.1046 13 16 13C14.8954 13 14 12.1046 14 11C14.0033 9.89678 14.8968 9.0033 16 9ZM20 17H12V16C12 14.6704 14.6704 14 16 14C17.3296 14 20 14.6704 20 16V17Z"
          :fill="color"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconSvgSnmmiDirectory',
  props: {
    color: {
      type: String,
      default: '#000000',
    },
    size: {
      type: Number,
      default: null,
    },
  },
  computed: {
    iconSize() {
      return this.size ? `${this.size}px` : '44px'
    },
  },
}
</script>

<style scoped></style>